import type { CmmdTaskStatus } from "@cmmd-forge/contracts";

import { STATUS_CONFIGS } from "./statusConfig";
import { formatStatusDisplayLabel } from "./taskRowFormatting";

interface TaskDetailStatusPropertyProps {
  readonly status: string | null;
  readonly draftStatus: CmmdTaskStatus;
  readonly editable: boolean;
  readonly className: string;
  readonly onChange: (status: CmmdTaskStatus) => void;
}

export function TaskDetailStatusProperty({
  status,
  draftStatus,
  editable,
  className,
  onChange,
}: TaskDetailStatusPropertyProps) {
  return (
    <div className="group grid grid-cols-[96px_minmax(0,1fr)] items-center gap-3 border-b border-border/60 py-2.5 last:border-0">
      <span className="text-xs font-medium text-muted-foreground/62">Status</span>
      <div className="min-w-0 text-sm text-muted-foreground group-hover:text-foreground/86">
        {editable ? (
          <select
            data-testid="quick-edit-status"
            value={draftStatus}
            onChange={(event) => onChange(event.currentTarget.value as CmmdTaskStatus)}
            className={className}
          >
            {STATUS_CONFIGS.map((option) => (
              <option key={option.status} value={option.status}>
                {option.label}
              </option>
            ))}
          </select>
        ) : (
          formatStatusDisplayLabel(status)
        )}
      </div>
    </div>
  );
}
